<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <div class="banner-content">
          <div class="banner-content-white-text">
            <h1>WE WILL MAKE YOUR <span>BUSINESS</span><br> <span class="block">MODERN</span></h1>
            <h3>以声学科技为笔，绘就未来音频新蓝图，伟思特声学，与您共创美好听觉世界。</h3>
            <el-button ref="gradientButton1" style="
              width: 150px;
              height: 50px;
              padding: 10px 20px;
              color: #000022;
              border-radius: 5px;"
                       @click="goToAbout">关于我们
            </el-button>
            <el-button ref="gradientButton" style="
              width: 150px;
              height: 50px;
              padding: 10px 20px;
              color: #000022;
              border-radius: 5px;"
                       @mouseenter="startGradientAnimation"
                       @mouseleave="stopGradientAnimation"
                       @click="goToContact">联系我们
            </el-button>
          </div>
        </div>
        <div class="about-us-container">
          <div class="about-us-content">
            <h1>关于我们</h1>
            <!--            西安伟思特声学科技有限公司成立于2022年11月28日，是一家专注于声学技术研发与应用的高科技企业。我们致力于通过先进的声学技术，为客户提供专业的声学解决方案，涵盖声学产品开发、声学工程设计、噪声与振动控制等多个领域。-->
            <p>
              西安伟思特声学科技有限公司成立于2022年11月28日，是一家专注于声学技术研发与应用的高科技企业。我们致力于通过先进的声学技术，为客户提供专业的声学解决方案，涵盖声学产品开发、声学工程设计、噪声与振动控制等多个领域。</p>
            <h3>我们的使命与愿景</h3>
            <Strong>使命：</Strong>
            通过创新的声学技术，为客户创造更安静、更舒适、更高效的生活与工作环境。<br>
            <Strong>愿景：</Strong>
            成为声学领域的领先者，推动声学技术在各个行业的广泛应用，助力社会的可持续发展。
            <h3>我们的服务</h3>
            <Strong>声学产品开发：</Strong>
            我们的团队将为您提供专业的声学产品开发服务，包括声学产品的设计、制造、测试等。<br>
            <Strong>声学工程设计：</Strong>
            我们的团队将为您提供专业的声学工程设计服务，包括声学工程设计的咨询、设计、实施等。<br>
            <Strong>噪声与振动控制：</Strong>
            我们的团队将为您提供专业的噪声与振动控制服务，包括噪声控制、振动控制等。<br>
          </div>
          <div class="about-us-pic">
            <el-carousel autoplay height="450px">
              <el-carousel-item v-for="item in carouselImages" :key="item.id">
                <img :src="item.url" :alt="item.alt" style="width: 100%; height: 100%; object-fit: cover;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <div class="partners">
          <div class="partners-content" style="text-align: center">
            <h1>合作伙伴 </h1>
          </div>
          <div class="content-wrapper">
            <div class="header-section">
              <div class="partners-container" ref="partnersContainer" @mouseenter="stopAnimation"
                   @mouseleave="startAnimation">
                <div class="partners-track" ref="partnersTrack" :style="{ left: trackPosition + 'px' }">
                  <div class="partner-card" v-for="(partner, index) in duplicatedPartners" :key="index">
                    <div class="partner-logo-container" >
                      <img class="partner-logo" :src="$store.state.baseApi + partner.partnerLogo" :alt="partner.partnerName">
                    </div>
                    <h3 class="partner-name">{{ partner.partnerName }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="end" style="text-align: center;margin-bottom: 100px">
          <h2>
            感谢您对西安伟思特声学科技有限公司的关注与支持！
            <br>
            我们将继续努力，为您提供更好的服务。
            <br>
            如有任何问题或建议，欢迎您联系我们。
          </h2>
        </div>

        <div class="end1" style="text-align: center;margin-bottom: 100px">
          <a href="http://www.weste-group.com/" target="_blank"><img src="@/assets/logo3.jpg" style="width: 250px"></a>
          <h3>
            东莞市伟思特智能科技有限公司是一家专注于智能检测设备研发、生产与销售的高新技术企业，
            其产品涵盖气密性检测、防水测试、音频测试及视觉检测设备等，广泛应用于汽车、手机、数码等领域，
            为众多知名企业如比亚迪、富士康等提供智能制造解决方案。          </h3>
        </div>
      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>

<script>
import AppHead from './common/AppHeader.vue';
import AppBody from './common/AppPageBody.vue'
import AppFoot from './common/AppFoot.vue'

export default {
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  data() {
    return {
      hue: 0,
      hue1: 0,
      animationFrameId: null,
      carouselImages: [
        {id: 1, url: require('@/assets/img/about-img-1.jpg'), alt: '第一张图片'},
        {id: 2, url: require('@/assets/img/about-img-2.jpg'), alt: '第二张图片'}
      ],
      trackPosition: 0,
      animationId: null,
      partners: []
    };
  },
  created() {
    this.getPartnerLogo();
  },
  computed: {
    duplicatedPartners() {
      return [...this.partners, ...this.partners];
    }
  },
  beforeDestroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  },
  mounted() {
    this.startGradientAnimation();
    this.startAnimation();
  },
  watch: {},
  methods: {
    goToAbout() {
      this.$router.push('/about');
    },
    goToContact() {
      this.$router.push('/contact');
    },
    getPartnerLogo() {
      this.$api.getPartner().then(res => {
        if (res.code === 200) {
          this.partners = res.data.list;
        }
      })
    },
    startGradientAnimation() {
      const button = this.$refs.gradientButton.$el;
      const button1 = this.$refs.gradientButton1.$el;
      const updateGradient = () => {
        /*        // 计算新的色相值
                this.hue = (this.hue + 0.17) % 30+150;
                this.hue1 = (this.hue1 + 0.23) % 30+150;*/
        // 使用正弦函数实现平滑的颜色循环变化 (160±30之间循环)
        const now = Date.now() / 1000;
        const cycleSpeed = 0.5; // 控制变化速度
        const hueRange = 30; // 色相变化范围
        this.hue = 160 + Math.sin(now * cycleSpeed * 1.2) * hueRange;
        this.hue1 = 160 + Math.sin(now * cycleSpeed * 1.3) * hueRange;

        // 生成渐变背景样式
        const gradient = `linear-gradient(45deg, hsl(${this.hue}, 100%, 50%), hsl(${this.hue + 60}, 100%, 50%))`;
        const gradient1 = `linear-gradient(45deg, hsl(${this.hue1}, 100%, 50%), hsl(${this.hue1 + 60}, 100%, 50%))`;

        // 设置按钮的背景样式
        button.style.background = gradient;
        button1.style.background = gradient1;

        // 使用 requestAnimationFrame 循环更新，并记录动画帧 ID
        this.animationFrameId = requestAnimationFrame(updateGradient);
      };
      // 启动动画
      updateGradient();
    },
    stopGradientAnimation() {
      // 取消动画帧
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
      // 鼠标移出后恢复默认背景
      const button = this.$refs.gradientButton.$el;
      button.style.background = '';
    },
    startAnimation() {
      const track = document.querySelector('.partners-track');
      const animate = () => {
        this.trackPosition -= 1;
        const trackWidth = this.$refs.partnersTrack.offsetWidth;
        // 当移动超过原始内容宽度时，重置位置
        if (Math.abs(this.trackPosition) >= trackWidth / 2) {
          //重新加载该组件
          track.style.transition = 'transform 1s ease';
          this.trackPosition = 0;
        }
        this.animationId = requestAnimationFrame(animate);
      };
      animate();
    },
    stopAnimation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    }
  }
}
</script>

<style scoped>

.banner-content {
  width: 100%;
  background-image: url("../../assets/img/banner.jpg");
  margin-top: -30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 795px;
}

/* 添加伪元素作为半透明层 */
.banner-content::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1; /* 确保半透明层在背景图片之上 */
}

.banner-content-white-text {
  position: absolute;
  top: 40%;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 2; /* 确保文字在半透明层之上 */
}

.about-us-container {
  margin: 100px auto 0;
  width: 80%;
  /* 使用 Flex 布局 */
  display: flex;
  /* 允许子元素换行 */
  flex-wrap: wrap;
  /* 子元素之间无间距 */
  gap: 50px;
}

.about-us-content {
  padding-bottom: 100px;
  width: calc(50% - 40px);
}

.about-us-pic {
  /* 调整宽度，减去一半的间距 */
  width: calc(50% - 10px);
  //padding-bottom: 100px;
}

/* 图片自适应容器 */
.about-us-pic img {
  width: 100%;
  height: auto;
  display: block;
}

.banner-content-white-text h1 {
  font-size: 36px;
  margin-bottom: 20px;
}


.content-wrapper {
  width: 70%;
  margin: 0 auto;
  padding: 0 20px;
}

.header-section {
  padding: 60px 0;
  text-align: center;
}


.partners-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 240px;
}

.partners-track {
  position: absolute;
  display: flex;
  transition: left 0.1s linear;
  height: 100%;
}

.partner-card {
  width: 240px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin: 0 15px;
  transition: all 0.3s ease;
}

.partner-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.partner-logo-container {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.partner-logo {
  width: 160px;
  height: 100%;
  object-fit: contain;
}

.partner-name {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-align: center;
}
.end1 {
  width: 60%; /* 容器宽度占页面的 70% */
  margin-left: auto; /* 左边距自动 */
  margin-right: auto; /* 右边距自动，实现居中 */
  word-wrap: break-word; /* 允许长单词或 URL 地址换行到下一行 */
  overflow-wrap: break-word; /* 现代浏览器推荐使用的换行属性 */
}

/* ====== 移动端适配（与项目统一断点 768px） ====== */
@media screen and (max-width: 768px) {
  /* Banner */
  .banner-content {
    min-height: 320px;
  }
  .banner-content-white-text {
    width: 90%;
    top: 55%;
  }
  .banner-content-white-text h1 {
    font-size: 22px;
    margin-bottom: 14px;
  }
  .banner-content-white-text h3 {
    font-size: 14px;
    line-height: 1.6;
    padding: 0 8px;
  }
  .banner-content-white-text .el-button {
    width: 120px !important;
    height: 42px !important;
    margin: 6px !important;
    font-size: 14px;
  }

  /* 关于我们 */
  .about-us-container {
    width: 90%;
    margin-top: 50px;
    gap: 30px;
    flex-direction: column;
  }
  .about-us-content,
  .about-us-pic {
    width: 100%;
    padding-bottom: 0;
  }
  .about-us-content h1 {
    font-size: 26px;
  }
  .about-us-content h3 {
    font-size: 18px;
  }
  .about-us-content p,
  .about-us-content strong {
    font-size: 14px;
    line-height: 1.7;
  }
  /* 轮播图：PC 端由组件 height="450px" 控制，手机端固定 200px 且完整显示图片 */
  .about-us-pic,
  .about-us-pic .el-carousel {
    overflow: hidden;
  }
  .about-us-pic .el-carousel,
  .about-us-pic .el-carousel__container,
  .about-us-pic .el-carousel__item {
    height: 200px !important;
  }
  .about-us-pic .el-carousel__item img {
    object-fit: contain !important;
  }

  /* 合作伙伴 */
  .content-wrapper {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
  }
  .header-section {
    padding: 30px 0;
  }
  .partners-container {
    height: 200px;
  }
  .partner-card {
    width: 180px;
    padding: 20px;
    margin: 0 10px;
  }
  .partner-logo-container {
    height: 90px;
  }
  .partner-logo {
    width: 120px;
  }
  .partner-name {
    font-size: 15px;
  }

  /* 结尾 */
  .end {
    margin-bottom: 50px;
    padding: 0 16px;
  }
  .end h2 {
    font-size: 18px;
    line-height: 1.6;
  }
  .end1 {
    width: 90%;
    padding: 0 16px;
    box-sizing: border-box;
  }
  .end1 img {
    width: 180px !important;
  }
  .end1 h3 {
    font-size: 14px;
    line-height: 1.6;
  }
}
</style>